import { ArrowTurnDownRightIcon } from '@heroicons/react/24/outline';

import { Table } from '@/components/ui/daisy';
import { AssessmentCriteria } from '@/models/Assessment';

type AssessmentCriteriaTableRowProps = {
  criterion: AssessmentCriteria;
};

export default function AssessmentCriteriaTableRow({
  criterion,
}: AssessmentCriteriaTableRowProps) {
  return (
    <Table.Row data-testid="criterion-row">
      <Table.Cell className="px-6 text-xs text-base-content">
        <div className="flex items-center gap-3">
          <ArrowTurnDownRightIcon className="size-5 shrink-0 text-base-content/60" />
          <span className="text-xs">{criterion.name}</span>
        </div>
      </Table.Cell>
      <Table.Cell />
      <Table.Cell className="text-center text-sm text-base-content">
        {criterion.maxGrade}
      </Table.Cell>
      <Table.Cell className="max-w-11 w-20 p-2" />
      <Table.Cell className="max-w-11 w-20 p-2" />
    </Table.Row>
  );
}
